import Checkbox from '@/components/Checkbox';
import Input from '@/components/Input';
import Select from '@/components/Select';

const TableCell = ({ value, style, onChange, select }) => {
  switch (value?.type) {
    case 'select':
      return (
        <div className={'table-cell'} style={style} data-title={value.title}>
          <Select borderless value={(value.options || select?.options)?.find((x) => x.value === value.value) || value.value || null} options={value.options || select?.options} onChange={(e) => onChange(e)} {...value.props} />
        </div>
      );
    case 'checkbox':
      return (
        <div className={'table-cell'} style={style} data-title={value.title}>
          <Checkbox checked={value.value} onChange={(e) => onChange(e.target.checked)} {...value.props} />
        </div>
      );
    case 'input':
      return (
        <div className={'table-cell'} style={style} data-title={value.title}>
          <Input size={'sm'} value={value.value} onChange={(e) => onChange(e.target.value)} {...value.props} />
        </div>
      );
    case 'custom':
      return (
        <div className={'table-cell'} style={style} data-title={value.title}>
          {value.render(value)}
        </div>
      );
    default:
      return (
        <div className={'table-cell table-cell-text'} style={style} data-title={value.title}>
          <span>{value.value}</span>
        </div>
      );
  }
};

export default TableCell;
